import { withQuery } from "./query";
import { Get } from "./request";

export function GetAllEntityBasicInfo(
  dispatch,
  entityName,
  searchFilter
) {
  return Get(
    dispatch,
    withQuery("GetAllEntityBasicInfo", {
      entityname: entityName,
      searchfilter: searchFilter || undefined,
    })
  );
}

export function GetMultipleEntityBasicInfo(
  dispatch,
  lookups,
  sourceEntityName = ""
) {
  return Get(
    dispatch,
    withQuery("GetMultipleEntityBasicInfo", {
      entitynames: lookups.map((l) => l.entityName).join(","),
      searchfilters: lookups.map((l) => l.searchFilter).join(","),
      sourceentityname: sourceEntityName || undefined,
    })
  );
}

export function GetAllEntityDetailedInfo(
  dispatch,
  entityName,
  showInactiveRecords
) {
  return Get(
    dispatch,
    withQuery("GetAllEntityDetailedInfo", {
      entityname: entityName,
      getinactiverecords: showInactiveRecords,
    })
  );
}

export function GetDefaultValuesForEntity(dispatch, entityName) {
  return Get(
    dispatch,
    withQuery("GetDefaultValuesForEntity", { entityname: entityName })
  );
}

export function GetEntityAttributes(dispatch, entityName) {
  return Get(
    dispatch,
    withQuery("GetEntityAttributes", { entityname: entityName })
  );
}

export function GetEntityAudits(dispatch, label, id) {
  return Get(dispatch, withQuery("GetEntityAudits", { label, id }));
}

export function GetBlacklistEntityAudits(dispatch) {
  return Get(dispatch, "GetBlacklistEntityAudits");
}

export function GetEntityAuditsByLoggingId(
  dispatch,
  label,
  loggingId
) {
  return Get(
    dispatch,
    withQuery("GetEntityAuditsByLoggingId", { label, loggingid: loggingId })
  );
}

export function GetEntityRecordById(dispatch, entityName, id) {
  return Get(
    dispatch,
    withQuery("GetEntityRecordById", { entityname: entityName, id })
  );
}

export function GetRelatedEntityRecordsForContact(
  dispatch,
  entityName,
  contactId
) {
  return Get(
    dispatch,
    withQuery("GetRelatedEntityRecordsForContact", {
      entityname: entityName,
      contactid: contactId,
    })
  );
}

export function GetPageData(dispatch, entityName, id, formId) {
  return Get(
    dispatch,
    withQuery("GetPageData", {
      entityname: entityName,
      id,
      formid: formId || undefined,
    })
  );
}
